import Vue from 'vue';

export default {

  SET_SEARCHTERM(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  SET_CURRENT_SITE(state, selectedSite) {
    state.selectedSite = selectedSite
  },
  UNSET_CURRENT_SITE(state, selectedSite) {
    state.selectedSite = ''
  },
  SET_APPLICATION_MODE(state, mode) {
    state.applicationMode = mode;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js